import React, { useEffect, useState } from "react";
import { Col, Row, Button, Input, Label, Badge } from "reactstrap";
import { showAlert } from "components/Common/commonFunctions";
import { getListAssignLocation } from "actions/subUser";
import { assignLocationList } from "constants/assignLocation";
import { addAssignLocation } from "actions/subUser";
import CommonTable from "components/ReactTable/Table";
import { useDispatch, useSelector } from "react-redux";
import {
  fixedWidthCustomStyle,
  DEFAULT_RECORDS_PER_PAGE,
} from "components/Common/constants";
import Select, { components } from "react-select";
import { getRegionList } from "actions/job";
import { regionList } from "constants/job";
import { ASSIGN_STATUS_OPTIONS } from "components/Common/constants";

export const LocationTable = ({
  activeTabId,
  decodedId,
  notify,
  // assignedLocationIds,
  // setAssignedLocationIds,
}) => {
  const dispatch = useDispatch();
  const assignLocationListData = useSelector(
    (state) => state.assignLocation.assignLocationList,
  );
  //region list data
  const regionListData = useSelector((state) => state.job.regionList);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const action = activeTabId === "assign" ? "Unassign" : "Assign";
  const [locationListState, setLocationListState] = useState({
    isLoading: true,
    error: "",
    noRecords: false,
  });
  //filters
  const [filterState, setFilterState] = useState({
    searchString: "",
    region: null,
    assignStatus: ASSIGN_STATUS_OPTIONS.find((o) => o.value === "ALL"),
    filterParams: {
      filters: [],
      searchString: "",
      assign: ""
    },
  });
  const [showLoaderOnClick, setShowLoaderOnClick] = useState(false);
  const [pageNum, setPageNum] = useState(1);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    getRegionList(dispatch);
    return () => {
      dispatch({ type: regionList, payload: {} });
    };
  }, [dispatch]);

  useEffect(() => {
    //clear the previous
    dispatch({
      type: assignLocationList,
      payload: {},
    });

    const fetchLocations = async () => {
      setLocationListState({
        isLoading: true,
        error: "",
        noRecords: false,
      });

      await getListAssignLocation(
        dispatch,
        decodedId,
        {
          page: pageNum,
          ...(activeTabId === "assign" && { assign: "ASSIGNED" }),
          ...(activeTabId === "unassign" &&
            filterState.assignStatus?.value !== "ALL" && {
            assign: filterState.assignStatus.value,
          }),
        },
        filterState.filterParams.filters,
        filterState.filterParams.searchString,
      );
    };

    if (decodedId) {
      fetchLocations();
    }
  }, [activeTabId, decodedId, pageNum, filterState.filterParams]);

  useEffect(() => {
    if (assignLocationListData?.code === 200) {
      setLocationListState({
        isLoading: false,
        error: "",
        noRecords:
          assignLocationListData?.data?.userLocationAssignmentResponse
            ?.length === 0,
      });
    } else if (
      assignLocationListData?.code ||
      assignLocationListData?.message
    ) {
      setLocationListState({
        isLoading: false,
        error: assignLocationListData?.message || "Failed to fetch locations.",
        noRecords: false,
      });
    }
  }, [assignLocationListData]);

  // useEffect(() => {
  //   if (
  //     activeTabId === "assign" &&
  //     assignLocationListData?.code === 200 &&
  // assignedLocationIds.length === 0
  // ) {
  // setAssignedLocationIds(
  //   assignLocationListData.data.userLocationAssignmentResponse.map(
  //     (item) => item.ID,
  //   ),
  // );
  //   }
  // }, [assignLocationListData, activeTabId]);

  const totalRecords =
    filterState.filterParams.filters.length > 0 ||
      filterState.filterParams.searchString
      ? assignLocationListData?.data?.totalFilteredRecords
      : activeTabId === "assign"
        ? assignLocationListData?.data?.totalAssignedLocations
        : assignLocationListData?.data?.totalCustomerLocations;

  const totalLocations =
    activeTabId === "assign"
      ? assignLocationListData?.data?.totalAssignedLocations
      : assignLocationListData?.data?.totalCustomerLocations;

  const totalTabsLocations = activeTabId === "assign"
    ? assignLocationListData?.data?.totalAssignedLocations
    : assignLocationListData?.data?.totalUnassingedLocations;

  const formattedListData =
    assignLocationListData?.data?.userLocationAssignmentResponse?.map(
      (item, index) => ({
        srNo: (pageNum - 1) * DEFAULT_RECORDS_PER_PAGE + index + 1,
        id: item.ID,
        region: item?.region?.name || "-",
        outletName: item?.outletName || "-",
        city: item?.city?.name || "-",
        postCode: item?.postCode || "-",
        address: item?.address || "-",
        formattedAddress: item?.mapDetails?.formattedAddress || "-",
        contactName: item?.contactName || "-",
        contactNo: item?.contactNo || "-",
        email: item?.email || "-",
        assignmentStatus: item?.assignmentStatus || "-",
      }),
    );

  const handleCheckboxChange = (id) => {
    setSelectedLocations((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  const handleSelectAll = (e) => {
    if (e.target.checked && selectedLocations?.length === 0) {
      if (activeTabId === "unassign") {
        const unassignedIds = formattedListData
          .filter((item) => item.assignmentStatus === "UNASSIGNED")
          .map((item) => item.id);

        setSelectedLocations(unassignedIds);
      } else {
        setSelectedLocations(formattedListData.map((item) => item.id));
      }
    } else {
      setSelectedLocations([]);
    }
  };

  const handleAssignUnassign = () => {
    const count = isAllSelected ? totalTabsLocations : selectedLocations.length;
    const isPlural = count > 1;

    const actionText = isAllSelected
      ? `${action.toLowerCase()} all`
      : `${action.toLowerCase()} the selected`;

    showAlert({
      title: `Are you sure you want to ${actionText} ${isPlural ? "locations" : "location"} to this sub user?`,
      message: `${count} ${isPlural ? "locations" : "location"} will be ${action.toLowerCase()}ed.`,
      type: "warning",
      confirmStyle: "default",
      cancelStyle: "secondary",
      confirmText: "Yes",
      cancelText: "Cancel",
      onConfirm: handleAssignConfirm,
      onCancel: () => { },
    });
  };

  const handleAssignConfirm = async () => {
    setIsProcessing(true);
    try {
      let body = {
        userID: decodedId,
        action: "",
        customerLocations: [],
      };
      let customerLocations = [];

      if (isAllSelected) {
        // Assign/Unassign ALL
        body.action =
          activeTabId === "assign"
            ? "UNASSIGN_ALL"
            : "ASSIGN_ALL";
      } else {
        // Assign/Unassign Selected
        if (activeTabId === "assign") {
          // Unassign selected
          customerLocations = selectedLocations;
          body.action = "UNASSIGN";
        } else {
          // Assign selected
          customerLocations = [
            ...new Set([...selectedLocations]),
          ];
          body.action = "ASSIGN";
        }

        body.customerLocations = customerLocations;
      }

      // const body = {
      //   userID: decodedId,
      //   action: activeTabId === "assign" ? "UNASSIGN" : "ASSIGN",
      //   customerLocations,
      // };
      const res = await addAssignLocation(body);

      if (res?.code === 200) {
        notify("success", res?.message || "Locations updated successfully.");
        // setAssignedLocationIds(customerLocations); //update the list
        setSelectedLocations([]);
        setIsAllSelected(false);

        getListAssignLocation(
          dispatch,
          decodedId,
          {
            page: pageNum,
            ...(activeTabId === "assign" && { assign: "ASSIGNED" }),
            ...(activeTabId === "unassign" &&
              filterState.assignStatus?.value !== "ALL" && {
              assign: filterState.assignStatus.value,
            }),
          },
          filterState.filterParams.filters,
          filterState.filterParams.searchString,
        );
        if (pageNum !== 1) setPageNum(1);
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Failed to update locations!";

        notify("danger", message);
      }
    } catch (error) {
      const message = Array.isArray(error?.response?.data?.message)
        ? error.response.data.message[0]?.Msg
        : error?.response?.data?.message ||
        error?.message ||
        "Something went wrong.";

      notify("danger", message);
    } finally {
      setIsProcessing(false);
    }
  };

  const hideSelectAllCheckbox =
    activeTabId === "unassign" &&
    formattedListData?.length > 0 &&
    formattedListData.every(
      (item) => item.assignmentStatus === "ASSIGNED"
    );

  const columns = [
    {
      Header: (
        !hideSelectAllCheckbox ? <Input
          type="checkbox"
          checked={
            formattedListData?.length > 0 &&
            selectedLocations.length === formattedListData.length || isAllSelected
          }
          className="table-checkbox m-n2"
          onChange={handleSelectAll}
        /> : (<></>)
      ),
      accessor: "select",
      sortable: false,
      disableSortBy: true,
      filterable: false,
      className:"col-check-box",
      Cell: ({ row }) => (
        (activeTabId === "unassign" && row?.original?.assignmentStatus === "UNASSIGNED") ? <Input
          type="checkbox"
          className="m-n2"
          checked={isAllSelected || selectedLocations.includes(row.original.id)}
          onChange={() => handleCheckboxChange(row.original.id)}
        /> : activeTabId === "assign" ? <Input
          type="checkbox"
          className="m-n2"
          checked={isAllSelected || selectedLocations.includes(row.original.id)}
          onChange={() => handleCheckboxChange(row.original.id)}
        /> : (<></>)
      ),
    },
    {
      Header: "Sr. No.",
      accessor: "srNo",
      className: "col-srNo",
    },
    {
      Header: "Outlet Name",
      accessor: "outletName",
      className: "col-outletName",
    },
    {
      Header: "Region",
      accessor: "region",
      className: "col-outleRegion",
    },
    {
      Header: "City",
      accessor: "city",
      className: "col-outleRegion",
    },
    {
      Header: "Post Code",
      accessor: "postCode",
      className: "col-post-code"
    },
    {
      Header: "Address",
      accessor: "formattedAddress",
      className: "col-address",
    },
    {
      Header: "Contact Person Info",
      accessor: "contactName",
      className: "col-person-info",
      Cell: ({ row }) => {
        const { contactName, contactNo } = row?.original;
        return (
          <div>
            <div className="d-flex align-items-center mb-1 text-wrap-cell">
              <i className="fa fa-user mr-2 text-light" />
              <span>{contactName || "-"}</span>
            </div>
            <div className="d-flex align-items-center">
              <i className="fa fa-phone mr-2 text-light" />
              +966 {contactNo}
            </div>
          </div>
        );
      },
    },
    {
      Header: "Contact Person Email",
      accessor: "email",
      className: "col-person-email",
    },
    ...(activeTabId === "unassign"
      ? [
        {
          Header: "Assignment Status",
          accessor: "assignmentStatus",
          className: "col-loc-status",
          Cell: ({ value }) => (
            <Badge color={value === "ASSIGNED" ? "success" : "warning"} pill>
              {value}
            </Badge>
          ),
        },
      ]
      : []),
  ];

  const buildFilterParams = () => {
    const filters = [];

    if (filterState.region) {
      filters.push({
        field: "RegionID",
        condition: "eq",
        filterValues: [String(filterState.region.ID)],
      });
    }

    if (
      activeTabId === "unassign" &&
      filterState.assignStatus &&
      filterState.assignStatus.value !== "ALL"
    ) {
      filters.push({
        field: "AssignmentStatus",
        condition: "eq",
        filterValues: [filterState.assignStatus.value],
      });
    }

    return {
      filters,
      searchString: filterState.searchString.trim(),
    };
  };

  const handleSearch = () => {
    const searchString = filterState.searchString.trim();
    const assignSelected = filterState.assignStatus?.value || "";

    // if nothing selected/entered, do nothing
    if (!searchString && !filterState.region && (!assignSelected || assignSelected === "ALL")) {
      return;
    }
    const newParams = buildFilterParams();
    if (
      JSON.stringify(filterState.filterParams) === JSON.stringify(newParams)
    ) {
      return;
    }
    setLocationListState((prev) => ({
      ...prev,
      isLoading: true,
      error: "",
      noRecords: false,
    }));
    setShowLoaderOnClick(true);
    setFilterState((prev) => ({
      ...prev,
      filterParams: newParams,
    }));

    setPageNum(1);
    setTimeout(() => {
      setShowLoaderOnClick(false);
    }, 600);
  };

  const handleClear = () => {
    setLocationListState({
      isLoading: true,
      error: "",
      noRecords: false,
    });

    setFilterState({
      searchString: "",
      region: null,
      assignStatus: ASSIGN_STATUS_OPTIONS.find((o) => o.value === "ALL"),
      filterParams: {
        filters: [],
        searchString: "",
        assign: ""
      },
    });
    if (pageNum !== 1) setPageNum(1);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  // Custom Option Renderer
  const Option = (props) => (
    <components.Option {...props}>
      <Badge color={props.data.color} pill>
        {props.data.label}
      </Badge>
    </components.Option>
  );

  // Custom SingleValue Renderer (for the selected value)
  const SingleValue = (props) => (
    <components.SingleValue {...props}>
      <Badge color={props.data.color} pill>
        {props.data.label}
      </Badge>
    </components.SingleValue>
  );

  return (
    <>
      {isProcessing && (
        <div className="loading-overlay">
          <div className="loading-card">
            <i className="fa fa-spinner fa-spin fa-2x text-deep-blue mb-3" />
            <div className="font-weight-bold text-dark">
              Processing… Please wait.
            </div>
          </div>
        </div>
      )}
      <div className="d-flex align-items-center">
        <div className="d-flex flex-wrap align-items-center justify-content-start filter-group">
          <Input
            type="text"
            placeholder="Search by outlet, contact details or email"
            className="mr-2 mb-2 filter-input-xl "
            value={filterState.searchString}
            onChange={(e) =>
              setFilterState((prev) => ({
                ...prev,
                searchString: e.target.value,
              }))
            }
            autoComplete="off"
            onKeyDown={handleKeyDown}
            maxLength={200}
          />

          <Select
            className="mr-2 mb-2 filter-select"
            options={regionListData?.data?.region}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.ID}
            placeholder="Region"
            classNamePrefix="react-select"
            styles={fixedWidthCustomStyle()}
            value={filterState.region}
            autoComplete="off"
            onChange={(selected) => {
              setFilterState((prev) => ({
                ...prev,
                region: selected,
              }));
            }}
            onKeyDown={handleKeyDown}
          />

          {activeTabId === "unassign" && <Select
            className="mr-2 mb-2 filter-select"
            options={ASSIGN_STATUS_OPTIONS}
            getOptionLabel={(option) => option.label}
            getOptionValue={(option) => option.value}
            placeholder="Assign Status"
            classNamePrefix="react-select"
            styles={fixedWidthCustomStyle()}
            value={filterState.assignStatus}
            autoComplete="off"
            onChange={(selected) => {
              setFilterState((prev) => ({ ...prev, assignStatus: selected }));
            }}
            components={{ Option, SingleValue }}
            onKeyDown={handleKeyDown}
          />}

          <Button
            color="default"
            className="d-flex justify-content-center align-items-center mb-3 filter-btn btn-simple mt-2 mr-1"
            onClick={handleSearch}
          >
            {showLoaderOnClick ? (
              <i className="fa fa-spinner fa-spin search-loader" />
            ) : (
              <>
                <i className="fa fa-search mr-1" />
                Search
              </>
            )}
          </Button>

          {(filterState.filterParams.filters.length > 0 ||
            filterState.filterParams.searchString || filterState.filterParams.assign) && (
              <Button
                color="default"
                className="mb-3 justify-content-center align-items-center mt-2 filter-btn btn-simple"
                onClick={handleClear}
              >
                <i className="fa fa-times mr-1" /> Clear
              </Button>
            )}
        </div>
      </div>
      {totalTabsLocations > 0 && <Row className="align-items-center mb-3 mt-3">
        <Col md="8">
          <div className="d-flex align-items-center ml-1">
            <input
              id="selectAllLocations"
              type="checkbox"
              checked={isAllSelected}
              className="checkbox-lg"
              onChange={(e) => {
                setIsAllSelected(e.target.checked);
                setSelectedLocations([]);
              }}
            />

            <Label
              for="selectAllLocations"
              className="mb-0 ml-2 mt-0 select-location"
            >
              Select all <strong>{totalTabsLocations}</strong>{activeTabId === "unassign" ? " unassigned " : ""} locations
            </Label>
          </div>
        </Col>

        <Col md="4" className="text-right">
          {(selectedLocations.length > 0 || isAllSelected) && (
            <>
              <Button
                size="sm"
                color={action === "Assign" ? "default" : "secondary"}
                onClick={handleAssignUnassign}
              >
                {action}  {isAllSelected
                  ? `(${totalTabsLocations})`
                  : `(${selectedLocations.length})`}
              </Button>
            </>
          )}
        </Col>

      </Row>}
      <Row>
        <Col md={12}>
          <div className="mt-2">
            {totalLocations > 0 && (
              <div className="mt-2 mx-1">
                {(filterState.filterParams.filters.length > 0 ||
                  filterState.filterParams.searchString) ? (
                  <span className="font-weight-bold">
                    Showing {assignLocationListData?.data?.totalFilteredRecords}{" "}
                    of {totalLocations} Locations
                  </span>
                ) : (
                  <span className="font-weight-bold">
                    Total Locations : {totalLocations}
                  </span>
                )}
              </div>
            )}
          </div>

          {locationListState.isLoading ||
            assignLocationListData?.code !== 200 ? (
            <div className="loaderContainer">
              <i className="fa fa-spinner fa-spin fa-2xl loader" />
            </div>
          ) : locationListState.error ? (
            <div className="loaderContainer text-danger">
              {locationListState.error}
            </div>
          ) : locationListState.noRecords ? (
            <div className="loaderContainer text-muted">
              No locations added yet.
            </div>
          ) : (
            <div className="table-responsive">
              <CommonTable
                data={formattedListData || []}
                columns={columns}
                resizable={false}
                showPaginationBottom
                activePage={pageNum}
                totalPages={Math.ceil(
                  (totalRecords || 0) / DEFAULT_RECORDS_PER_PAGE,
                )}
                setPageNum={setPageNum}
              />
            </div>
          )}
        </Col>
      </Row>
    </>
  );
};
